import { useRef } from 'react';
import { isFailedRequest } from '@utils/isFailedRequest';

type SettledQuery = {
  error: unknown;
  errorUpdatedAt: number;
  dataUpdatedAt: number;
  isFetching: boolean;
};

export function useCheckFailure({
  error,
  errorUpdatedAt,
  dataUpdatedAt,
  isFetching,
}: SettledQuery) {
  const lastError = useRef<unknown>(null);
  if (error) lastError.current = error;

  const isCheckFailed = errorUpdatedAt > dataUpdatedAt && isFailedRequest(lastError.current);

  return { isCheckFailed, isRetrying: isCheckFailed && isFetching };
}
